/* src/app/shared/components/update-modal/update-modal.component.scss */
.update-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 16px;
  gap: 16px;
}
.update-icon {
  font-size: 64px;
  color: var(--ion-color-primary);
  margin-bottom: 8px;
}
.update-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: var(--ion-text-color);
}
.update-body {
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0 0 8px;
  color: var(--ion-color-medium);
}
.update-version {
  font-size: 0.8rem;
  color: var(--ion-color-medium-shade);
  margin: 0 0 8px;
}
.update-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
}
.update-actions ion-button {
  margin: 0;
}
/*# sourceMappingURL=update-modal.component.css.map */
